import Swal from "sweetalert2";
import {responses} from "@/services/responses";

  // window.gateway = `http://192.168.1.177:8080/KazangPaymentGateway/`
  // window.gateway = `http://192.168.1.197:8081/KazangPaymentGateway/`
 // window.gateway = `http://Musonda:8080/KazangPaymentGateway/`
// window.gateway = 'https://lna.pos.co.zm/KazangPaymentGatewayTest '

  // window.gateway = `http://192.168.1.177:8080/KazangPaymentGateway/`
  // window.gateway = `http://192.168.1.197:8081/KazangPaymentGateway/`
 // window.gateway = `http://Musonda:8080/KazangPaymentGateway/`
// window.gateway = 'https://lna.pos.co.zm/KazangPaymentGatewayTest '

  // window.gateway = `http://localhost:8287/KazangPaymentGateway/`
  window.gateway = `https://lna.pos.co.zm/KazangPaymentGateway/`

    window.gatewayv2 = `https://lna.pos.co.zm/KazangPaymentGateway/V2/`
    // window.gatewayv2 = `https://Musonda:8080/KazangPaymentGateway/V2/`
  // window.gatewayv2 = `http://192.168.1.177:8080/KazangPaymentGateway/V2/`
  // window.gatewayv2 = `http://192.168.1.197:8081/KazangPaymentGateway/V2/`

  /*
   * PRODUCTION:
   *   KDIY API (Chicken Little)        on https://lna.pos.co.zm/ChickenLittle/
   *   Kazang Payment Gateway V2         on https://lna.pos.co.zm/KazangPaymentGateway/V2/
   *   KDIY Ross Order App               on https://kdiy.pos.co.zm/
   *   KDIY Admin Portal                 on https://kdiy.pos.co.zm/AdminPortal/
   */
  window.ChickenLittle = `https://lna.pos.co.zm/ChickenLittle/`

window.responses = responses;
window.Swal = Swal;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}